import React from "react";

export type IconName =
  | "home"
  | "dashboard"
  | "sales"
  | "reports"
  | "items"
  | "staff"
  | "kasir"
  | "receipt"
  | "devices"
  | "business"
  | "users"
  | "subscription"
  | "logout"
  | "plus"
  | "search"
  | "check"
  | "warning"
  | "download"
  | "print"
  | "menu"
  | "close"
  | "calendar"
  | "clock"
  | "trendUp"
  | "trendDown"
  | "chevronRight";

export function Icon({
  name,
  size = 20,
  className = "",
}: {
  name: IconName;
  size?: number;
  className?: string;
}): React.ReactElement {
  const props = {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.85,
    strokeLinecap: "round" as const,
    strokeLinejoin: "round" as const,
    className: `icon ${className}`.trim(),
    "aria-hidden": true,
  };

  switch (name) {
    case "home":
      return (
        <svg {...props}>
          <path d="M3 10.5L12 3l9 7.5V20a1 1 0 0 1-1 1h-5.5v-6h-5v6H4a1 1 0 0 1-1-1v-9.5z" />
        </svg>
      );
    case "dashboard":
      return (
        <svg {...props}>
          <rect x="3" y="3" width="7.5" height="9" rx="1.5" />
          <rect x="13.5" y="3" width="7.5" height="5" rx="1.5" />
          <rect x="13.5" y="11" width="7.5" height="10" rx="1.5" />
          <rect x="3" y="15" width="7.5" height="6" rx="1.5" />
        </svg>
      );
    case "sales":
      return (
        <svg {...props}>
          <path d="M6 3h12a1 1 0 0 1 1 1v16l-2.5-1.5L14 20l-2-1.5L10 20l-2.5-1.5L5 20V4a1 1 0 0 1 1-1z" />
          <path d="M9 8h6M9 12h6M9 16h4" />
        </svg>
      );
    case "reports":
      return (
        <svg {...props}>
          <path d="M4 19.5h16" />
          <path d="M7 16V9" />
          <path d="M12 16V5" />
          <path d="M17 16v-4" />
        </svg>
      );
    case "items":
      return (
        <svg {...props}>
          <path d="M4 7h16M4 12h16M4 17h10" />
          <circle cx="18" cy="17" r="2" />
        </svg>
      );
    case "staff":
      return (
        <svg {...props}>
          <circle cx="9" cy="8" r="3.5" />
          <path d="M3.5 19.5c0-3 2.5-5 5.5-5s5.5 2 5.5 5" />
          <circle cx="17" cy="9" r="2.5" />
          <path d="M15.5 14.8c2.2.3 4 1.8 4 4.7" />
        </svg>
      );
    case "kasir":
      return (
        <svg {...props}>
          <rect x="3" y="4" width="18" height="16" rx="2" />
          <path d="M7 8h10M7 12h3M14 12h3M7 16h3M14 16h3" />
        </svg>
      );
    case "receipt":
      return (
        <svg {...props}>
          <path d="M7 3h10a1 1 0 0 1 1 1v16l-2-1.3-2 1.3-2-1.3-2 1.3-2-1.3-2 1.3V4a1 1 0 0 1 1-1z" />
          <path d="M9.5 8h5M9.5 12h5" />
        </svg>
      );
    case "devices":
      return (
        <svg {...props}>
          <rect x="6" y="2.5" width="12" height="19" rx="2" />
          <path d="M10 6h4M11.5 18h1" />
        </svg>
      );
    case "business":
      return (
        <svg {...props}>
          <path d="M3 9.5L5 4h14l2 5.5" />
          <path d="M4 9.5h16V20a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9.5z" />
          <path d="M9.5 21v-6h5v6" />
        </svg>
      );
    case "users":
      return (
        <svg {...props}>
          <circle cx="12" cy="8" r="3.5" />
          <path d="M5 19.5c0-3.3 3.1-5.5 7-5.5s7 2.2 7 5.5" />
        </svg>
      );
    case "subscription":
      return (
        <svg {...props}>
          <path d="M12 2.5l2.8 5.7 6.2.9-4.5 4.4 1.1 6.2L12 16.8 6.4 19.7l1.1-6.2L3 9.1l6.2-.9L12 2.5z" />
        </svg>
      );
    case "logout":
      return (
        <svg {...props}>
          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
          <path d="M16 17l5-5-5-5" />
          <path d="M21 12H9" />
        </svg>
      );
    case "plus":
      return (
        <svg {...props}>
          <path d="M12 5v14M5 12h14" />
        </svg>
      );
    case "search":
      return (
        <svg {...props}>
          <circle cx="11" cy="11" r="6.5" />
          <path d="M16 16l4.5 4.5" />
        </svg>
      );
    case "check":
      return (
        <svg {...props}>
          <path d="M5 12.5l4.5 4.5L19 7.5" />
        </svg>
      );
    case "warning":
      return (
        <svg {...props}>
          <path d="M12 3.5L2.5 20h19L12 3.5z" />
          <path d="M12 9.5v4.5M12 17h.01" />
        </svg>
      );
    case "download":
      return (
        <svg {...props}>
          <path d="M12 4v11m0 0l-4-4m4 4l4-4" />
          <path d="M4 19h16" />
        </svg>
      );
    case "print":
      return (
        <svg {...props}>
          <path d="M6 9V4h12v5" />
          <rect x="4" y="9" width="16" height="8" rx="1.5" />
          <path d="M7 14h10v6H7z" />
        </svg>
      );
    case "menu":
      return (
        <svg {...props}>
          <path d="M4 7h16M4 12h16M4 17h12" />
        </svg>
      );
    case "close":
      return (
        <svg {...props}>
          <path d="M6 6l12 12M18 6L6 18" />
        </svg>
      );
    case "calendar":
      return (
        <svg {...props}>
          <rect x="3.5" y="4.5" width="17" height="16" rx="2" />
          <path d="M8 3v3M16 3v3M3.5 9.5h17" />
        </svg>
      );
    case "clock":
      return (
        <svg {...props}>
          <circle cx="12" cy="12" r="8.5" />
          <path d="M12 7.5V12l3 2" />
        </svg>
      );
    case "trendUp":
      return (
        <svg {...props}>
          <path d="M3 16l6-6 4 4 8-8" />
          <path d="M15 6h6v6" />
        </svg>
      );
    case "trendDown":
      return (
        <svg {...props}>
          <path d="M3 8l6 6 4-4 8 8" />
          <path d="M15 18h6v-6" />
        </svg>
      );
    case "chevronRight":
      return (
        <svg {...props}>
          <path d="M9 6l6 6-6 6" />
        </svg>
      );
  }
}
